<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="content-left-top-cornor">
  <div class="container-fluid mt-0">
    <p-confirmDialog class="confirm-message" appendTo="body"></p-confirmDialog>
    <p-confirmDialog key="warning" appendTo="body"></p-confirmDialog>
    <div class="row">
      <div class="col-12 flex p-0">
        <div class="col-3">
          <div class="col-12" id="topGroup">
            <div class="col-10" id="multiselectDiv" style="padding-left: 0px;padding-right: 0px;">
              <div class="ui-inputgroup" id="filterLabel">
                <button pButton class="theme-button noHover labelButton" type="button" label="Filter"></button>
                <p-multiSelect [options]="filterOptions" (onChange)="onApplyFilter()" [(ngModel)]="selectedStates"
                  id="multiselectStatuses" [style]="{'width':'65%' ,'height':'38px'}" [maxSelectedLabels]="1">
                  <ng-template let-item pTemplate="selectedItem">
                    <span style="vertical-align:middle">{{item.label}}</span>
                  </ng-template>
                  <ng-template let-status pTemplate="item">
                    {{status.label}}
                  </ng-template>
                </p-multiSelect>
              </div>
            </div>
            <div class="col-2" id="refreshBatchesDiv">
              <button pButton style="width: 74%;" class="refreshBatches" icon="fa fa-refresh" (click)="onApplyFilter()"></button>
            </div>
            <div class="row col-12 pt-0 pb-0" id="datePicker">
              <div class="col-6 pt-0 pb-0">
                <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                  [inputStyle]="{'width':'76%','height':'100%'}" dateFormat="dd.mm.yy" [showIcon]="true" placeholder="From"
                  showButtonBar="true" (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()"
                  [maxDate]="toDate"></p-calendar>
              </div>
              <div class="col-6 pt-0 pb-0">
                <p-calendar [(ngModel)]="toDate" [minDate]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                  [inputStyle]="{'width':'76%','height':'100%'}" dateFormat="dd.mm.yy" [showIcon]="true" placeholder="To"
                  showButtonBar="true" (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()"></p-calendar>
              </div>
            </div>
            <div class="row col-12" style=" margin-left: 1%;">
              <label class="m-0">Number Of Batches Matching Filter: <label class="m-0 font-weight-bold text-success"
                  style="font-size: 1.2rem;">{{batches == null ? 0: batches.length}}</label></label>
            </div>
          </div>
        </div>
        <div class="col-9">
          <div class="col-12 flex" id="topGroup">

            <div class="col-4" style="padding: 0% 0% 2% 0%;">
              <div class="ui-inputgroup userIdLable" style="margin-top: 10px;">
                <button pButton class="theme-button noHover labelButton" type="button" label="User ID" style="width: 44%;"></button>
                <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="userID" maxlength="4"
                  style="width: 50%; border-radius: 1px; height: 35px;" placeholder="User ID" />
              </div>
              <div class="ui-inputgroup userIdLable flex" style="margin-top: 10px;">
                <div>
                  <p-dropdown placeholder="Choose Search" [options]="searchFilterList"
                  name="searchFilterList" [(ngModel)]="selectedSearchFilter">
                  </p-dropdown>
                </div>
                <input pInputText name="SearchSample" [(ngModel)]="valueToSearch" size="17"
                (keydown.enter)="searchForBatchWIthFilter()" style=" border-radius: 1px;width: 48%; height: 39px;" />
                <button pButton icon="fa fa-search" style="width: 6%;height: 2.48rem;" [disabled]="searchButtonDisabledIf()"  (click)="searchForBatchWIthFilter()">
                </button>
            </div>
            </div>
              <div class="col-5 topDivspacing" style="text-align:left;margin: 0px 0px;padding: 0% 0%;">
              <div class="col-12 headers topDivspacing" style="height: 32px;" id="topDiv">
                <div class="col-3">
                <h5 style="color:#1F89CE; font-size: 19px;">
                    Batch</h5> </div>
                    <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                    <h5>
                    :
                </h5>
              </div>
                <div class="col-8">
                  <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;"><span style="color: red">{{selectedBatch.lowMolarity? '! ' : ''}}</span>{{selectedBatch?.batchID}}</strong>
                  </h5>
                </div>
              </div>
              <div class="col-12 headers" style="height: 32px;">
                <div class="col-3">
                <h5  style="color:#1F89CE; font-size: 19px;">
                    Status
                  </h5></div>
                  <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                    <h5>
                    :
                </h5>
              </div>
                  <div class="col-8">
                    <h5 style="color:#1F89CE; font-size: 19px;">
                    <strong style="margin: 3%;">{{selectedBatch?.statusOfTheBatch}} </strong>
                  </h5>
                  </div>
              </div>
              <div class="col-12 headers" style="height: 32px;">
                <div class="col-3">
                <h5 style="color:#1F89CE; font-size: 19px;">
                    Sender
                  </h5></div>
                  <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                    <h5>
                    :
                </h5>
              </div>
                  <div class="col-8">
                    <h5 style="color:#1F89CE; font-size: 19px;">
                      <strong style="margin: 3%;">{{getfunction()}} </strong>
                  </h5>
                </div>
            </div>
              <div  class="col-12 headers" style="height: 32px;">
                <div class="col-3">
                <h5 style="color:#1F89CE; font-size: 19px;">
                    Samples  </h5></div>
                    <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                      <h5>
                      :
                  </h5>
                </div>
                  <div class="col-8">
                    <h5 style="color:#1F89CE; font-size: 19px;">
                    <strong style="margin: 3%;">{{getSamplesCount()}} </strong>
                  </h5>
                </div>
            </div>
              <div  class="col-12 headers" style="height: 32px;">
                <div class="col-3">
                <h5 style="color:#1F89CE; font-size: 19px; width: 120px;">
                    External Id </h5></div>
                    <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                      <h5>
                      :
                  </h5>
                </div>
                  <div class="col-8">
                    <h5 style="color:#1F89CE; font-size: 19px;">
                    <strong style="margin: 3%;">{{selectedBatch?.externalIdentification}} </strong>
                  </h5>
                </div>
            </div>
          </div>
          <div class="col-3 topDivspacing pl-0">
            <div class="ui-inputgroup pl-0" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="History"></button>
              <div style="width: 52%;">
                <p-dropdown *ngIf="selectedBatch.wellType == 'WELL384'"  [options]="groupedBatches" [(ngModel)]="batchHistoryId"
                placeholder="Select a Batch" [group]="true" (onChange)="searchBatch()" scrollHeight="500px">
                <ng-template let-group pTemplate="group">
                  <div class="p-d-flex p-ai-center mt-2">
                    <span>{{group.label}}</span>
                  </div>
                </ng-template>
              </p-dropdown>
              <p-dropdown *ngIf="selectedBatch.wellType == 'WELL96'"  [options]="batchHistory" [(ngModel)]="batchHistoryId"
                placeholder="Select a Batch"  (onChange)="searchBatch()">
              </p-dropdown></div>
            </div>
            <div>
              <button pButton [icon]="getViewPlateIcon(showPlateView)"  class="buttonsRound" [label]="getPlateViewButtonLabel(showPlateView)"
                id="plateView" (click)="togglePlateView()" [disabled]="!selectedBatch.batchID || deactivatePlateView"></button>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div class="col-12 flex p-0">
        <div class="col-3">
          <div class = "tableLHS1">
            <p-table [value]="batches" selectionMode="single" scrollHeight="80vh" [scrollable]="true"
            (onRowSelect)="batchViewVisbility($event)" (onRowUnselect)="removeBatchSelection()" [loading]="loading">
              <ng-template pTemplate="header">
                <tr >
                  <th scope="col" style="width: 40%;" class="batch">Batch ID</th>
                  <th scope="col" class="status">Status</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-batch>
                <tr [pSelectableRow]="batch">
                  <td style="width: 40%;"
                    [class]="(batch?.rushSample == true) ? 'rushBody pr-0': 'normalBody pr-0'">
                    <span style="color: red">{{batch.lowMolarity? '! ' : ''}}</span>{{batch?.batchID}}
                  </td>
                  <td [class]="(batch?.rushSample == true) ? 'rushBody pr-0': 'normalBody pr-0'">
                    {{batch?.statusOfTheBatch}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="col-9">
          <div class="col-12" id="tableDiv" [hidden]="showPlateView" *ngIf="!isVisible">
            <div class="col-12" id="tableDiv">
              <table aria-describedby="Processing table" id="processingTable"
                style="border: 1px solid black; width: 100%; height: 100%; table-layout:fixed;">
                <thead id="processingTableHeader">
                  <tr>
                    <th scope="col">Plate Transfer</th>
                    <th scope="col">Normalization</th>
                    <th scope="col">Index Ligation</th>
                    <th scope="col">Library QC</th>
                  </tr>
                </thead>
                <tbody id="processingTableBody">
                  <tr>

                    <td id="processingTableBody">
                      <div class="col-12 parent mb-5">
                        <div class="col-8 childSD ui-inputgroup" style="margin: 4% 1% 0% 1%;">
                          <button pButton class="theme-button noHover labelButton buttonStyle" type="button" label="Scan Aliquot Plate-ID"></button>
                          <input pInputText class="inputButton inputButtonWidth"
                            [(ngModel)]="selectedBatch.aliquotPlateID"
                            [placeholder]="selectedBatch.batchID ? selectedBatch.batchID+'_A' : ''"
                            (focusout)="checkForAliquotPlateID()"
                            (keydown.enter)="checkForAliquotPlateID()"/>
                        </div>
                        <div class="col-4 sibling">
                          <button class="btn p-0 m-0" style="width: 8%;">
                            <em class="fa fa-print"></em>
                          </button>
                        </div>
                        <div class="col-8 child">
                          <button pButton label="Plate Transfer" (click)="saveBatchStatus('PLATE_TRANSFERRED')"
                          [disabled]="disableButton(0, 'TRANSFER_PLATE') || (!selectedBatch.aliquotPlateID || selectedBatch.aliquotPlateID==='')" class="buttonsRound startButton" >
                          </button>
                        </div>
                        <div class="col-4 sibling child" *ngIf="isValidProcessStep('TRANSFER_PLATE')">
                          {{getProcessStepStartTimestamp('TRANSFER_PLATE') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepStartPuid('TRANSFER_PLATE')}}
                        </div>
                      </div>
                      <div class="col-12 parent mt-5">
                        <div class="col-8 child">
                          <button pButton label="Go To Tagment." (click)="skipProcessSteps('GO_TO_TAGMENTATION')"
                          [disabled]="disableButton(0, 'SAMPLE_QC')" class="buttonsRound VioletButtons" >
                          </button>
                        </div>
                      </div>
                    </td>

                    <td id="processingTableBody">

                      <div class="col-12 parent flex" >
                        <div class="col-8 childSD ui-inputgroup" style="margin: 2% auto;">
                          <button pButton class="theme-button noHover labelButton buttonStyle" type="button" label="Scan Norm. Plate-ID"></button>
                          <input pInputText class="inputButton inputButtonWidth"
                            [(ngModel)]="selectedBatch.normalizationPlateID"
                            [placeholder]="selectedBatch.batchID ? selectedBatch.batchID+'_N' : ''"
                            (focusout)="checkForNormalizationPlateID()"
                            (keydown.enter)="checkForNormalizationPlateID()"/>
                        </div>
                        <div class="col-4 sibling">
                          <button class="btn p-0 m-0" style="width: 8%;">
                            <em class="fa fa-print"></em>
                          </button>
                        </div>
                      </div>
                      <div class="col-12 parent">
                        <div class="col-8 child">
                          <button pButton label="Start Normaliz." (click)="saveBatchStatus('START_NORMALIZATION')"
                          [disabled]="disableButton(0, 'NORMALIZATION') || (!selectedBatch.normalizationPlateID || selectedBatch.normalizationPlateID==='')"  class="buttonsRound startButton" ></button>
                        </div>
                        <div class="col-4 sibling child" *ngIf="isValidProcessStep('NORMALIZATION')">
                          {{getProcessStepStartTimestamp('NORMALIZATION') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepStartPuid('NORMALIZATION')}}
                        </div>
                      </div>

                      <div class="col-12 parent">
                        <div class="col-8 child">
                          <button pButton label="Norm. Workfile" class="buttonsRound VioletButtons"
                          [disabled]="disableButton(1, 'NORMALIZATION')" (click)="downloadNormalizationWorkFile()" ></button>
                        </div>
                        <div class="col-4 child action-timer-div" *ngIf="">
                          <span class="action-timer-span"> </span>
                        </div>
                      </div>

                      <div class="col-12 parent">
                        <div class="col-8 child ui-inputgroup" style="margin: 2% 0%;">
                          <button pButton class="theme-button noHover labelButton buttonStyle" type="button" label="Control Position"></button>
                          <input pInputText class="inputButton inputButtonWidth"/>
                        </div>
                      </div>

                      <div class="col-12 parent">
                        <div class="col-8 child">
                          <button pButton label="Complete Normaliz." (click)="saveBatchStatus('COMPLETE_NORMALIZATION')"
                          [disabled]="disableButton(1, 'NORMALIZATION')"  class="buttonsRound endButton" ></button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('NORMALIZATION')">
                          {{getProcessStepEndTimestamp('NORMALIZATION') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepEndPuid('NORMALIZATION')}}
                        </div>
                      </div>
                    </td>

                    <td id="processingTableBody">
                      <div class="col-12 parent">
                        <div class="col-2 child1">
                          <button type="button"  pButton class="buttonsRound1 downLoadButton" (click)="showChemicalPopup('INDEX_LIGATION')"
                            label="LOT"></button>
                        </div>
                      </div>
                      <div class="col-12 parent" >
                        <div class="col-8 child">
                          <button pButton label="Start Ligation" (click)="saveBatchStatus('START_LIGATION')"
                          [disabled]="disableButton(0, 'INDEX_LIGATION')" class="buttonsRound startButton">
                          </button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('INDEX_LIGATION')">
                          {{getProcessStepStartTimestamp('INDEX_LIGATION') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepStartPuid('INDEX_LIGATION')}}
                        </div>
                      </div>
                      <div class="col-12 parent" >
                        <div class="col-10 child ui-inputgroup" id="inputClass" style="margin: 2% 0%;">
                          <button pButton class="theme-button noHover labelButton buttonStyle" type="button"   label="TagPlate"></button>
                          <p-dropdown [style]="{'width':'9rem','height':'3rem'}" placeholder="Tag Plate" [options]="tags" [disabled]="disableButton(1, 'INDEX_LIGATION') || selectedBatch?.tagPlateBarcode"
                            [(ngModel)]="selectedTagPlate" name="customertList" (onChange)="openVerifyReceptionPopup()">
                          </p-dropdown>
                        </div>
                      </div>
                      <p style="margin:2%;">Used Plate Barcode: {{ selectedBatch?.tagPlateBarcode }}</p>
                      <div class="col-12 parent">
                        <div class="col-8 child">
                          <button pButton label="Complete Ligation"  (click)="saveBatchStatus('COMPLETE_LIGATION')"
                          [disabled]="disableButton(1, 'INDEX_LIGATION') || !(selectedBatch?.tagPlateBarcode)" class="buttonsRound endButton" ></button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('INDEX_LIGATION')">
                          {{getProcessStepEndTimestamp('INDEX_LIGATION') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepEndPuid('INDEX_LIGATION')}}
                        </div>
                      </div>
                    </td>

                    <td id="processingTableBody">
                      <div class="col-12 parent" >
                        <div class="col-8 child">
                          <button pButton label="Start Lib QC"  (click)="saveBatchStatus('START_LIB_QC')"
                          [disabled]="disableButton(0, 'LIBRARY_QC')" class="buttonsRound startButton">
                          </button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('LIBRARY_QC')">
                          {{getProcessStepStartTimestamp('LIBRARY_QC') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepStartPuid('LIBRARY_QC')}}
                        </div>
                      </div>

                      <div class="col-12 parent">
                        <div class="col-8 child ui-inputgroup" style="margin: 2% 0%;">
                          <button pButton class="theme-button noHover labelButton buttonStyle" type="button" label="Lib QC Machine"></button>
                          <input pInputText class="inputButton inputButtonWidth" [(ngModel)]="selectedBatch.libQcMachine"
                          placeholder="Scan LibQC Equipment" [disabled]="disableLibQCMachine()"
                          (keydown.enter)="checkMachineBarcode()"/>
                        </div>
                      </div>

                      <div class="col-12 parent" >
                        <div class="col-8 child">
                          <button pButton label="qPCR Workfile" [disabled]="disableQpcrWorkFileButton()"
                          class="buttonsRound VioletButtons"  (click)= "downloadqPCRBioRadWorkfile()">
                          </button>
                        </div>
                      </div>

                      <div class="col-12 parent" >
                        <p style="margin:2%;"><u>Upload Result File:</u></p>
                        <div class="col-12 flex p-0 ui-inputgroup">
                          <input #qpcrFile [disabled]="!selectedBatch.batchID" pInputText class="form-control" name="profile" type="file"
                            accept=".txt,.csv" (change)="onFileSelectQPCR($event)" id="fileChooser" placeholder="Upload  Files"
                            #fileInput />
                          <button pButton icon="fa fa-upload" type="submit" id="uploadButtonExcel"
                            (click)="fileUploadQPCROrQubit(fileInput)" [disabled]="isFileNotSelected || disableButton(1, 'LIBRARY_QC')" class="uploadBtn">
                          </button>
                        </div>
                      </div>

                      <div class="col-12 parent">
                        <div class="col-8 child">
                          <button pButton label="Complete Lib QC" (click)="saveBatchStatus('COMPLETE_LIB_QC')"
                          [disabled]="!isQCPRFileUploaded() || disableCompleLibQCButton() || disableButton(1, 'LIBRARY_QC')" class="buttonsRound endButton" ></button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('LIBRARY_QC')">
                          {{getProcessStepEndTimestamp('LIBRARY_QC') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepEndPuid('LIBRARY_QC')}}
                        </div>
                      </div>

                      <div class="col-12 parent" >
                        <div class="col-8 child">
                          <button pButton label="LibQC Results" [disabled]="disableLibQCResultButton()"
                          class="buttonsRound VioletButtons"  (click)= "downloadLibQCResults()">
                          </button>
                        </div>
                      </div>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-12" id="tableDiv">
              <table id="processingTable" aria-describedby="Lysis section"
                style="width: 75%;border: 1px solid black; height: 100%; table-layout: fixed;">

                <thead id="processingTableHeader">
                  <tr>
                    <th scope="col">Sample QC</th>
                    <th scope="col">Tagmentation</th>
                    <th scope="col">Clean Up Libraries</th>
                  </tr>
                </thead>

                <tbody id="processingTableBody">
                  <tr>
                    <td id="processingTableBody">
                      <div class="col-12 parent mt-3">
                        <div class="col-8 child">
                          <button pButton label="Start Sample QC" (click)="saveBatchStatus('START_SAMPLE_QC')"
                          [disabled]="disableButton(0, 'SAMPLE_QC')" class="buttonsRound startButton">
                          </button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('SAMPLE_QC')">
                          {{getProcessStepStartTimestamp('SAMPLE_QC') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepStartPuid('SAMPLE_QC')}}
                        </div>
                      </div>

                      <div class="col-12 parent">
                        <div class="col-8 child">
                          <button pButton label="FLX Workfile" [disabled]="disableButton(1, 'SAMPLE_QC')"
                          class="buttonsRound VioletButtons"  (click)= "downloadFLXWorkFile()">
                          </button>
                        </div>
                        <div class="col-4 child action-timer-div" *ngIf="">
                          <span class="action-timer-span"> </span>
                        </div>
                      </div>
                      <div class="col-12 parent" >
                        <p style="margin:2%;"><u>Upload FLX Result File:</u></p>
                        <div class="col-12 flex p-0 ui-inputgroup">
                          <input [disabled]="!selectedBatch.batchID" #sampleQCFileInput pInputText class="form-control" name="profile" type="file"
                            accept=".txt" (change)="onFileSelect($event)" placeholder="Upload FLX Files" />
                          <button pButton icon="fa fa-upload" type="submit" id="uploadButtonExcel"
                            (click)="fileUpload(sampleQCFileInput)"  class="uploadBtn"
                            [disabled]="isSampleQCFileNotSelected || disableButton(1, 'SAMPLE_QC')">
                          </button>
                        </div>
                      </div>
                      <div class="col-12 parent">
                        <div class="col-8 child">
                          <button pButton label="Complete Sample QC" (click)="saveBatchStatus('COMPLETE_SAMPLE_QC')"
                          [disabled]="disableButton(1, 'SAMPLE_QC') || samplesWithHighConcentration.length>0 || !sampleQCPerformedForSelectedBatch" class="buttonsRound endButton" ></button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('SAMPLE_QC')">
                          {{getProcessStepEndTimestamp('SAMPLE_QC') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepEndPuid('SAMPLE_QC')}}
                        </div>
                      </div>
                      <div class="col-12 parent mt-2">
                        <div class="col-8 child">
                          <button pButton label="Skip Normaliz." (click)="skipProcessSteps('SKIP_NORMALIZATION')"
                          [disabled]="disableButton(0, 'NORMALIZATION')" class="buttonsRound VioletButtons" >
                          </button>
                        </div>
                      </div>
                    </td>
                    <td id="processingTableBody" style="padding: 0%">
                      <table aria-describedby="Processing table" id="processingTable"
                        style="width: 100%; table-layout:fixed;">
                        <tbody >
                          <tr>
                            <td>
                              <div class="col-12 parent">
                                <div class="col-2 child1">
                                  <button type="button"  pButton class="buttonsRound1 downLoadButton" (click)="showChemicalPopup('TAGMENTATION')"
                                    label="LOT"></button>
                                </div>
                              </div>
                              <div class="col-12 parent">
                                <div class="col-8 child">
                                  <button pButton label="Start Tagment." (click)="saveBatchStatus('START_TAGMENTATION')"
                                  [disabled]="disableButton(0, 'TAGMENTATION')" class="buttonsRound startButton">
                                </button>
                                </div>
                                <div class="col-4 sibling" *ngIf="isValidProcessStep('TAGMENTATION')">
                                  {{getProcessStepStartTimestamp('TAGMENTATION') | date: 'dd.MM.yy HH:mm'}} <br />
                                  {{getProcessStepStartPuid('TAGMENTATION')}}                           </div>
                              </div>
                              <div class="col-12 parent">
                                <div class="col-8 child">
                                  <button pButton label="Complete Tagment." (click)="saveBatchStatus('COMPLETE_TAGMENTATION')"
                                  [disabled]="disableButton(1, 'TAGMENTATION')" class="buttonsRound endButton">
                                </button>
                                </div>
                                <div class="col-4 sibling" *ngIf="isValidProcessStep('TAGMENTATION')">
                                  {{getProcessStepEndTimestamp('TAGMENTATION') | date: 'dd.MM.yy HH:mm'}} <br />
                                  {{getProcessStepEndPuid('TAGMENTATION')}}
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table aria-describedby="Processing table" id="processingTable"
                        style="border-top: 1px solid #1F89CE; width: 100%; table-layout:fixed;">
                        <tbody>
                          <tr>
                            <td>
                              <div class="col-12 parent">
                                <div class="col-2 child1">
                                  <button type="button"  pButton class="buttonsRound1 downLoadButton" (click)="showChemicalPopup('PURIFICATION')"
                                    label="LOT"></button>
                                </div>
                              </div>
                              <div class="col-12 parent">
                                <div class="col-8 child">
                                  <button pButton label="Start Purific." (click)="saveBatchStatus('START_PURIFICATION')"
                                  [disabled]="disableButton(0, 'PURIFICATION')" class="buttonsRound startButton">
                                </button>
                                </div>
                                <div class="col-4 sibling" *ngIf="isValidProcessStep('PURIFICATION')">
                                  {{getProcessStepStartTimestamp('PURIFICATION') | date: 'dd.MM.yy HH:mm'}} <br />
                                  {{getProcessStepStartPuid('PURIFICATION')}}
                                </div>
                              </div>
                              <div class="col-12 parent">
                                <div class="col-8 child">
                                  <button pButton label="Complete Purific." (click)="saveBatchStatus('COMPLETE_PURIFICATION')"
                                  [disabled]="disableButton(1, 'PURIFICATION')" class="buttonsRound endButton" ></button>
                                </div>
                                <div class="col-4 sibling" *ngIf="isValidProcessStep('PURIFICATION')">
                                  {{getProcessStepEndTimestamp('PURIFICATION') | date: 'dd.MM.yy HH:mm'}} <br />
                                  {{getProcessStepEndPuid('PURIFICATION')}}
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td id="processingTableBody">
                      <div class="col-12 flex parent">
                        <div class="col-8 childSD ui-inputgroup" style="margin: 2% auto;">
                          <button pButton class="theme-button noHover labelButton buttonStyle" type="button" label="Scan Clean Up Plate-ID"></button>
                          <input pInputText class="inputButton inputButtonWidth"
                            [(ngModel)]="selectedBatch.cleanUpPlateID"
                            [placeholder]="selectedBatch.batchID ? selectedBatch.batchID+'_C' : ''"
                            (focusout)="checkForCleanUpPlateID()"
                            (keydown.enter)="checkForCleanUpPlateID()"/>
                        </div>
                        <div class="col-2 sibling">
                          <button class="btn p-0 m-0" style="width: 8%;">
                            <em class="fa fa-print"></em>
                          </button>
                        </div>
                        <div class="col-2 child1" style="left:0px;">
                          <button type="button"  pButton class="buttonsRound1 downLoadButton" (click)="showChemicalPopup('CLEAN_UP')"
                            label="LOT"></button>
                        </div>
                      </div>
                      <div class="col-12 parent">
                        <div class="col-8 child">
                          <button pButton label="Start Clean Up" (click)="saveBatchStatus('START_CLEAN_UP')"
                          [disabled]="disableButton(0, 'CLEAN_UP') || (!selectedBatch.cleanUpPlateID || selectedBatch.cleanUpPlateID==='')"  class="buttonsRound startButton" ></button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('CLEAN_UP')">
                          {{getProcessStepStartTimestamp('CLEAN_UP') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepStartPuid('CLEAN_UP')}}
                        </div>
                      </div>
                      <div class="col-12 parent">
                        <div class="col-8 child">
                          <button pButton label="Clean Up Workfile" [disabled]="disableButton(1, 'CLEAN_UP')"
                          class="buttonsRound VioletButtons" (click)="downloadCleanUpWorkfile()">
                          </button>
                        </div>
                      </div>
                      <div class="col-12 parent">
                        <div class="col-8 child">
                          <button pButton label="Complete Clean Up"  (click)="saveBatchStatus('COMPLETE_CLEAN_UP')"
                          [disabled]="disableButton(1, 'CLEAN_UP')"  class="buttonsRound endButton" ></button>
                        </div>
                        <div class="col-4 sibling" *ngIf="isValidProcessStep('CLEAN_UP')">
                          {{getProcessStepEndTimestamp('CLEAN_UP') | date: 'dd.MM.yy HH:mm'}} <br />
                          {{getProcessStepEndPuid('CLEAN_UP')}}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 p-0" [hidden]="!showPlateView">
            <app-plate-view #plateView *ngIf="showPlateView" [selectedBatch]="selectedBatch" [puid]="puid" [selectedLabId]="selectedLabId" [totalPCRControls]="totalPCRControls"
             [showPlateView]="showPlateView" [mapOfTags]="mapOfTags" [viewMode]="plateViewMode" [sourceBatchSamplesMap]="sourceBatchSamplesMap"></app-plate-view>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Sample-QC Dilution" [(visible)]="sampleQcToBeDiluted" showEffect="fade" [modal]="true" [style.width]="'1700px'" position="top">
  <div style="font-weight: bold; font-size: medium;">
    {{sampleQCDilutionSubHeader}}
  </div>
  <div class="row">
    <div class="col-10">
      <table data-vertable="ver5" id="scanTable" aria-describedby="Detail View" class="table">
        <thead>
          <tr class="row100 head">
            <th class="column100 column1" scope="col"></th>
            <th class="column100 column1" scope="col" *ngFor="let col of columnHeaders; let k = index">{{col}}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row100" *ngFor="let row of rowHeaders; let i = index;">
            <td class="column100 column1">{{row}}</td>
            <td class="column100 column1 noHover" *ngFor="let col of columnHeaders; let j = index" style="padding:0%">
              <input class="cellviewsold" pInputText type="text" name="sampleBarcode" dir="rtl"
                [value]="getSampleAt(i, j, plateMap).barcode" [ngStyle]="getSampleBackgroudColor(getSampleAt(i, j, plateMap))" readonly />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-2 sampleQcInfo">
      <div *ngIf="sampleQcPartialReupload" style="font-weight: bold;">
        Enter the Sample-ID's manual
      </div>
      <table aria-describedby="Samples with high QC concentration" id="sample-qc-high-conc">
        <tr>
          <th>Position</th>
          <th>Sample-ID</th>
        </tr>
        <tr *ngFor="let con of samplesWithHighConcentration">
          <td>{{getRowColStringFromPos(con.positionRow-1, con.prositionCol-1)}}</td>
          <td>{{con.barcode}}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="row">
    <div class="col-10"></div>
    <div class="col-2" style="text-align: center;">
      <button *ngIf="sampleQcPartialReupload" pButton label="Back to Upload"
        (click)="sampleQcBackToUpload()" class="buttonsRound startButton"> </button>
      <button *ngIf="sampleQcCompleteReupload" pButton label="FLX Workfile"
        (click)="sampleQcDownloadFLXWorkFile()" class="buttonsRound VioletButtons" >
        </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Enter Tag Plate Barcode" [(visible)]="verifyReceptionPUID" [modal]="true">
  <label class="text-danger">Scan the barcode of the Tag Plate</label>
  <div>
    <input class="batchInput" id="enteredScanPlateBarcode"  pInputText #focus1 type="text"
    [(ngModel)]="enteredScanPlateBarcode" maxlength="100" name="comment"
     placeholder="Enter Tag Plate Barcode" />
  </div>
  <p-footer>
    <button pButton type="button" [disabled]="assignButtonDisabled()" label="Assign" (click)="verifyReception(enteredScanPlateBarcode)"></button>
  </p-footer>
</p-dialog>

<p-dialog [(header)]="skipProcessStepsPopUpHeader" [(visible)]="skipProcessStepsPopUp" [modal]="true">
  <div>
    <div class="ui-inputgroup" style="margin: 2% auto;">
      <button pButton class="theme-button noHover labelButton" type="button" label="Scan Norm. Plate-ID"></button>
      <input pInputText class="inputButton" id="normalization-plate-input-field"
        [(ngModel)]="selectedBatch.normalizationPlateID"
        [placeholder]="selectedBatch.batchID ? selectedBatch.batchID+'_N' : ''"
        (focusout)="checkForNormalizationPlateID()"
        (keydown.enter)="checkForNormalizationPlateID()"/>
    </div>
  </div>
  <p-footer>
    <button pButton type="button" [disabled]="this.selectedBatch.normalizationPlateID !== this.selectedBatch.batchID+'_N'" [(label)]="skipProcessStepsPopUpHeader" (click)="saveBatchStatus(skipProcessStepsPopUpButtonStatus)"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Chemicals" [(visible)]="showDialogue" [focusOnShow]="true" [modal]="true" position="top" (onHide)="hideChemicalDialog(selectedBatch)" >
  <app-ma-chemicals-popup [selectedBatch]="selectedBatch" [selectedBeadChip]="null" [selectedProcessStep]="selectedProcessStep" [processStepChemicals]="processStepChemicals" [noChemicalEdit]="noChemicalEdit" 
    [isPlate]="false" [dialogOpen]="showDialogue" (backButtonEmitter)="hideChemicalDialog($event)" ></app-ma-chemicals-popup>
</p-dialog>
